import styled from 'styled-components';

export const Container = styled.div`
background-color: var(--surface-canvas);
`

export const Content = styled.div`
    box-sizing: border-box;
    color: var(--text-secondary);
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    h2 {
        margin-top: 33px;
        font-size: 1.813rem;
        font-weight: 700;
        
    }

    .settingProfile {
        background-color: var(--surface-canvas);
        box-sizing: border-box;
        
        width: 1074px;
        height: 229px;
        margin-left: 140px;
        padding: 24px;
        margin-top: 20px;
        border: var(--border-default) solid 1px;
        border-radius: 3px;

        h3 {
            font-weight: 700;
            font-size: .894rem;
            margin-bottom: 10px;
            margin-top: 10px;
        }

        label {
            font-size: .894rem;
            font-weight: 400;
        }

        input {
            font-weight: 400;
            font-size: .894rem;
            height: 2px;
            margin-bottom: 10px;
        }

        div {
            margin-bottom: 10px;
            height: 40px;
        }

        button {
            margin-top: 25px;
            font-size: .894rem;
            padding: 0.438rem 1.125rem;
            line-height: 1.54;
            border-radius: 60rem;
            
        }
        .save {
                background-color: var(--border-accent);
                border: solid 1px transparent;
                color: var(--surface-raised);
            }
        .back {
                border: var(--border-default) solid 1px;
                background-color: var(--surface-canvas);
                margin-left: 30px;
            }
    }

`